module.exports = __webpack_public_path__ + "static/media/Lunch-paid.c4b16d2c.png";